import React from "react";
import { Col, Container, Row } from "react-bootstrap";

import "../../flaticon/flaticon.css";
import "./style.css";

const Services = () => {
  return (
    <>
      <section id="service-section" className="service-section section_100">
        <Container>
          <Row className="align-items-center">
            <Col lg={5} md={12}>
              <div className="section-title  ">
                <h2>
                  Servicios para <span>mejorar</span> tu<br /> 
                  estrategia de precios en tienda
                </h2>
              </div>
            </Col>
            <Col lg={7} md={12}>
              <div className="section-para">
                <p>
                  Trabaja con información confiable en base a imágenes 
                  de las tiendas de tu competencia. Establece objetivos 
                  por categoría y deja que Bestore.ai haga el resto.
                </p>
              </div>
            </Col>
          </Row>
          <Row>
            <Col lg={4} md={6}>
              <div className="service-box">
                <div className="service-icon">
                  <i className="flaticon-chip" />
                </div>
                <div className="service-title">
                  <h3>Pricing competitivo Supermercados</h3>
                </div>
                <div className="service-desc">
                  <p>
                    Descubre la dinámica de precios de tu 
                    competencia ajustando canastas por 
                    cadena y hasta 10.000 SKU.
                  </p>
                </div>
                <div className="service-icon-bottom">
                  <i className="flaticon-chip" />
                </div>
              </div>
            </Col>
            <Col lg={4} md={6}>
              <div className="service-box  ">
                <div className="service-icon">
                  <i className="flaticon-picture" />
                </div>
                <div className="service-title">
                  <h3>Pricing competitivo Hard Discount y Conveniencia</h3>
                </div>
                <div className="service-desc">
                  <p>
                    Mejora tu estrategia de pricing 
                    optimizando tus KVI frente a tu 
                    competencia. Especial para canasta 
                    acotadas de 300 a 800 SKU.
                  </p>
                </div>
                <div className="service-icon-bottom">
                  <i className="flaticon-picture" />
                </div>
              </div>
            </Col>
            <Col lg={4} md={6}>
              <div className="service-box  ">
                <div className="service-icon">
                  <i className="flaticon-box" />
                </div>
                <div className="service-title">
                  <h3>Pricing competitivo <br /> Ecommerce</h3>
                </div>
                <div className="service-desc">
                  <p>
                    Todo el poder de nuestra tecnología 
                    aplicada en sitios ecommerce de tu 
                    competencia.
                  </p>
                </div>
                <div className="service-icon-bottom">
                  <i className="flaticon-box" />
                </div>
              </div>
            </Col>
            {/* <Col lg={4} md={6}>
              <div className="service-box  ">
                <div className="service-icon">
                  <i className="flaticon-mobile" />
                </div>
                <div className="service-title">
                  <h3>Participación en góndola (SOS)</h3>
                </div>
                <div className="service-desc">
                  <p>
                    Mide el nivel de participación (Share of Shelf) de tus categorías, 
                    compárate con tu competencia y acciona eficientemente para no perder espacio en góndola.
                  </p>
                </div>
                <div className="service-icon-bottom">
                  <i className="flaticon-mobile" />
                </div>
              </div>
            </Col>
            <Col lg={4} md={6}>
              <div className="service-box  ">
                <div className="service-icon">
                  <i className="flaticon-facial-recognition" />
                </div>
                <div className="service-title">
                  <h3>Planograma</h3>
                </div>
                <div className="service-desc">
                  <p>
                    Un layout inteligente maximiza las ventas. 
                    Monitorea el cumplimiento correcto del planograma diseñado e identifica áreas de mejora.
                  </p>
                </div>
                <div className="service-icon-bottom">
                  <i className="flaticon-facial-recognition" />
                </div>
              </div>
            </Col>
            <Col lg={4} md={6}>
              <div className="service-box  ">
                <div className="service-icon">
                  <i className="flaticon-video-player" />
                </div>
                <div className="service-title">
                  <h3>Tienda perfecta</h3>
                </div>
                <div className="service-desc">
                  <p>
                    Mide tu ejecución en PDV y asegúrate que tus productos en góndola 
                    estén disponibles en el lugar correcto, en el momento correcto y al precio correcto.
                  </p>
                </div>
                <div className="service-icon-bottom">
                  <i className="flaticon-video-player" />
                </div>
              </div>
            </Col> */}
          </Row>
        </Container>
      </section>
    </>
  );
};

export default Services;
